var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container"},[_c('svgIcon',{attrs:{"icon-holder-class":"nexon-logo","icon-id":"nexon-logo"}}),_c('img',{staticClass:"error-logo",attrs:{"src":_vm.errorImg}}),_c('h1',[_vm._v(_vm._s(_vm.$t('shop.404-not-found')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }